import React, {FC} from 'react';
import messages from '../../messages';
import {CreditCompact} from 'features/acounting/types/credit';
import {MODAL} from 'features/modal-notch/constants';
import {Archive, FileText} from 'react-feather';
import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';
import {Button, UncontrolledTooltip} from 'reactstrap';
import showModal from 'store/ui/actions/show-modal';
import {STATUS} from 'constants/status';
import clsx from 'clsx';
import Can from 'features/hylian-shield/can';

interface Props {
  creditData: CreditCompact;
}

const CreditsActions: FC<Props> = ({creditData}) => {
  const dispatch = useDispatch();

  const {t} = useTranslation();

  const {id: credit_id, status} = creditData;

  const updateCreditStatus = (newStatus: string) => {
    dispatch(
      showModal(MODAL.UPDATE_CREDIT_STATUS, {
        credit_id,
        status: newStatus,
        currentStatus: status,
      })
    );
  };

  return (
    <div className="d-flex gap-1">
      <Can action="edit" subject="accounting">
        <Button
          className={clsx(
            {
              'd-none': status === STATUS.REFUND || status === STATUS.ARCHIVED,
              'btn-success': status === STATUS.AVAILABLE,
              'btn-info': status === STATUS.USED,
            },
            'btn-sm'
          )}
          onClick={() => updateCreditStatus(STATUS.USED)}
          id={`tooltip-mark-as-used-${credit_id}`}
        >
          <FileText size={16} />
        </Button>
        <UncontrolledTooltip
          placement="top"
          target={`tooltip-mark-as-used-${credit_id}`}
        >
          {status === STATUS.AVAILABLE
            ? t(...messages.markAsUsed())
            : t(...messages.markAsAvailable())}
        </UncontrolledTooltip>

        <Button
          className={clsx(
            {
              'd-none':
                status !== STATUS.AVAILABLE &&
                status !== STATUS.ARCHIVED &&
                status !== STATUS.USED,
              'btn-danger':
                status === STATUS.AVAILABLE || status === STATUS.USED,
              'btn-default': status === STATUS.ARCHIVED,
            },
            'btn-sm'
          )}
          onClick={() => updateCreditStatus(STATUS.ARCHIVED)}
          id={`tooltip-archive-${credit_id}`}
        >
          <Archive size={16} />
        </Button>
        <UncontrolledTooltip
          placement="top"
          target={`tooltip-archive-${credit_id}`}
        >
          {status === STATUS.ARCHIVED
            ? t(...messages.removeFromArchive())
            : t(...messages.archive())}
        </UncontrolledTooltip>
      </Can>
    </div>
  );
};

export default CreditsActions;
